import AddComment from "./AddComment";
import AddCommentMutation from "./addCommentMutation";

export default AddCommentMutation(AddComment);



// WEBPACK FOOTER //
// ./src/components/AddComment/index.jsx